import { Button, Icon, SingleSelect } from '@opallabs/lapidary'
import { SUPPORTED_LANGUAGES } from './languages'
import * as styles from './styles'
import { CaptionRowState } from './types'

type CaptionRowProps = Readonly<{
  row: CaptionRowState
  onLanguageChange: (key: string, languageCode: string | null) => void
  onRemove: (key: string) => void
}>

const options = SUPPORTED_LANGUAGES.map((language) => ({
  label: language.name,
  value: language.system_name,
  trailingNode: <Icon ariaHidden={true} glyph="gem-check-circle" />,
}))

export const CaptionRow: React.FC<CaptionRowProps> = ({
  row,
  onLanguageChange,
  onRemove,
}) => {
  const selectedOption = options.find(
    (option) => option.value === row.language_code
  )

  return (
    <div css={styles.captionRow}>
      <span css={styles.filePill} title={row.filename ?? ''}>
        <Icon glyph="gem-file" ariaHidden={true} height={16} width={16} />
        <span css={styles.filePillName}>{row.filename ?? 'Caption file'}</span>
      </span>

      <div css={styles.languageSelect}>
        <SingleSelect.ControlledRoot
          options={options}
          selectedOption={selectedOption ?? null}
          onChange={(option) =>
            onLanguageChange(row.key, option?.value ?? null)
          }
        >
          <SingleSelect.Body isClearable={true}>
            <SingleSelect.Trigger hideTrailingNode={true}>
              <SingleSelect.TriggerText placeholder="Select language" />
            </SingleSelect.Trigger>
            <SingleSelect.Menu>
              <SingleSelect.MenuItems hideTrailingNodeUnlessSelected={true} />
            </SingleSelect.Menu>
          </SingleSelect.Body>
        </SingleSelect.ControlledRoot>
      </div>

      <Button
        ariaLabel={`Remove ${row.filename ?? 'caption'}`}
        css={styles.removeButton}
        icon={
          <Icon glyph="gem-close" ariaHidden={true} height={16} width={16} />
        }
        name="Remove caption"
        onClick={() => onRemove(row.key)}
        variant="ghost"
      />
    </div>
  )
}
